import React from "react";

const HtmlDisplay = ({ htmlContent }) => {
  return (
    <div>
      <pre>{htmlContent}</pre>
    </div>
  );
};

export default HtmlDisplay;
